import axios from 'api/axios'
import {
	AllowedModule,
	ClientInvoiceDetails,
	ClientTaxation,
	Currency,
	EdgePlatform,
} from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for addClient
 */

export interface AddClientBody {
	plan: {
		title: string
		storageAllowed: number
		billingCycle: 'MONTHLY' | 'YEARLY'
		perMonth: number
		perYear: number
		modules: AllowedModule[]
	}
	logo?: string
	organizationName: string
	email: string
	address?: string
	city?: string
	state?: string
	website?: string
	country: string
	mobileNumber: {
		mobile: string
		country: string
	}
	whatcxCharge: number
	whatcxChargeInbound: number
	whatcxChargeOutbound: number
	currency_selected: Currency
	taxation: ClientTaxation[]
	invoiceDetails: ClientInvoiceDetails[]
	csmUser: string[]
	notificationEmails?: string
	invoiceEmails?: string
	shouldGenerateAutoInvoice: boolean
	platform: EdgePlatform
	tdsEnabled: boolean
	broadcastLimit: number
}

/**
 * Type Interface for the Response object you get from addClient request if successful
 */
export interface AddClientResponse {
	statusCode: number
	message: string
}

/**
 * API call create a new Clients
 * @param body addClientBody - data to be send to backend for generating new client
 * @returns AdminResponse - Response object returned from the server
 */

export const addClient = async (body: AddClientBody) => {
	try {
		const { data } = await axios.post<AddClientResponse>(`client/new`, body)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default addClient
